import { DateTimePicker, type DateTimePickerProps } from "~/components/form/date-picker/DateTimePicker";

type TimePickerProps = Exclude<DateTimePickerProps, "mode">;

export const TimePicker = (datePickerProps: TimePickerProps) => {
    return <DateTimePicker {...datePickerProps} mode="time" />;
};
